import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FC, Fragment, ReactNode } from 'react'

const queryClient = new QueryClient()

interface GlobalProviderProps {
  children: ReactNode
}

const GlobalProvider: FC<GlobalProviderProps> = ({ children }) => {
  return (
    <Fragment>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID}>
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </GoogleOAuthProvider>
      {/* The global components of the album are mostly controlled with eventBus. */}
    </Fragment>
  )
}

GlobalProvider.displayName = 'GlobalProvider'

export default GlobalProvider
